import i18n from 'i18n-literally'

export const TASK_PRIORITY_LOW = 1
export const TASK_PRIORITY_MEDIUM = 2
export const TASK_PRIORITY_HIGH = 3

export const priorityOptions = [
  { get label() { return i18n`Low Priority` }, value: TASK_PRIORITY_LOW },
  { get label() { return i18n`Medium Priority` }, value: TASK_PRIORITY_MEDIUM },
  { get label() { return i18n`High Priority` }, value: TASK_PRIORITY_HIGH },
]

export const FACILITY_WIDE = Symbol.for('FACILITY_WIDE')
